// assets
import { EnvironmentOutlined } from "@ant-design/icons";
import { ScheduleOutlined } from "@ant-design/icons";
import { TeamOutlined } from "@ant-design/icons";
import { CalendarOutlined } from "@ant-design/icons";
import { CompassOutlined } from "@ant-design/icons";
import { BarChartOutlined } from "@ant-design/icons";
import {
  AuditOutlined,
  BulbOutlined,
  WarningOutlined,
} from "@ant-design/icons";

// type
import { NavItemType } from "types/menu";

const icons = {
  EnvironmentOutlined,
  ScheduleOutlined,
  TeamOutlined,
  CalendarOutlined,
  CompassOutlined,
  BarChartOutlined,
  AuditOutlined,
  BulbOutlined,
  WarningOutlined,
};

// ==============================|| MENU ITEMS - RUNWAY ||============================== //

const runway: NavItemType = {
  id: "runway",
  title: "Runway",
  type: "group",
  children: [
    {
      id: "runway-dashboard",
      title: "Overview",
      type: "item",
      url: "/dashboard",
      icon: icons.ScheduleOutlined,
    },
    {
      id: "runway-operations",
      title: "Operations",
      type: "collapse",
      icon: icons.EnvironmentOutlined,
      children: [
        {
          id: "runway-flights-2",
          title: "Flight Schedule",
          type: "item",
          url: "/flights-2",
          icon: icons.CompassOutlined,
        },
        {
          id: "runway-crowd-prediction",
          title: "Crowd Prediction",
          type: "item",
          url: "/crowd-prediction",
          icon: icons.CompassOutlined,
        },
        {
          id: "runway-task-timeline",
          title: "Task Timeline",
          type: "item",
          url: "/task-timeline",
          icon: icons.CalendarOutlined,
        },
        {
          id: "runway-staff-presence",
          title: "Staff Presence",
          type: "item",
          url: "/staff-presence",
          icon: icons.TeamOutlined,
        },
        {
          id: "runway-audit",
          title: "Audit",
          type: "item",
          url: "/audit",
          icon: icons.AuditOutlined,
        },
        {
          id: "runway-audit-recommendations",
          title: "Recommended Audits",
          type: "item",
          url: "/audit-recommendations",
          icon: icons.BulbOutlined,
        },
        {
          id: "runway-issues",
          title: "Issues",
          type: "item",
          url: "/issues",
          icon: icons.WarningOutlined,
        },
      ],
    },
    {
      id: "runway-planning",
      title: "Planning",
      type: "collapse",
      icon: icons.CalendarOutlined,
      children: [
        {
          id: "runway-shift-roster-control",
          title: "Shift Roster",
          type: "item",
          url: "/shift-roster-control",
          icon: icons.TeamOutlined,
        },
        {
          id: "runway-task-schedule",
          title: "Task Schedule",
          type: "item",
          url: "/task-schedule",
          icon: icons.CalendarOutlined,
        },
        {
          id: "runway-edit-timeline",
          title: "Edit Timeline",
          type: "item",
          url: "/edit-timeline",
          icon: icons.ScheduleOutlined,
        },
        {
          id: "runway-rescheduling",
          title: "Rescheduling",
          type: "item",
          url: "/rescheduling",
          icon: icons.CalendarOutlined,
        },
        {
          id: "runway-dynamic-lines",
          title: "Dynamic Lines",
          type: "item",
          url: "/dynamic-lines",
          icon: icons.ScheduleOutlined,
        },
      ],
    },
    {
      id: "runway-reports",
      title: "Reports",
      type: "collapse",
      icon: icons.BarChartOutlined,
      children: [
        {
          id: "runway-reports-tasks",
          title: "Tasks",
          type: "item",
          url: "/reports/tasks",
          icon: icons.BarChartOutlined,
        },
        {
          id: "runway-reports-task-history",
          title: "Task History",
          type: "item",
          url: "/task-history",
          icon: icons.ScheduleOutlined,
        },
        {
          id: "runway-reports-audits",
          title: "Audits",
          type: "item",
          url: "/reports/audits",
          icon: icons.AuditOutlined,
        },
        {
          id: "runway-reports-issues",
          title: "Issues",
          type: "item",
          url: "/reports/issues",
          icon: icons.WarningOutlined,
        },
        {
          id: "runway-reports-slas",
          title: "SLAs",
          type: "item",
          url: "/reports/slas",
          icon: icons.BarChartOutlined,
        },
      ],
    },
    {
      id: "runway-insights",
      title: "Insights",
      type: "collapse",
      icon: icons.CompassOutlined,
      children: [
        {
          id: "runway-traffic",
          title: "Traffic",
          type: "item",
          url: "/traffic",
          icon: icons.CompassOutlined,
        },
        {
          id: "runway-deterioration",
          title: "Deterioration",
          type: "item",
          url: "/deterioration",
          icon: icons.CompassOutlined,
        },
        {
          id: "runway-task-analysis",
          title: "Task Analysis (LH)",
          type: "item",
          url: "/task-analysis",
          icon: icons.CompassOutlined,
        },
        {
          id: "runway-task-intelligence",
          title: "Task Intelligence",
          type: "item",
          url: "/task-intelligence",
          icon: icons.CompassOutlined,
        },
        {
          id: "runway-flow-graph",
          title: "Flow Graph",
          type: "item",
          url: "/flow-graph",
          icon: icons.CompassOutlined,
        },
      ],
    },
    {
      id: "runway-tools",
      title: "Tools",
      type: "collapse",
      icon: icons.EnvironmentOutlined,
      children: [
        {
          id: "runway-map",
          title: "Airport overview map",
          type: "item",
          url: "/pearson-map",
          icon: icons.EnvironmentOutlined,
        },
        {
          id: "runway-facility-map",
          title: "Facility map",
          type: "item",
          url: "/facility-map",
          icon: icons.EnvironmentOutlined,
        },
        {
          id: "runway-facility-modelling",
          title: "Facility modelling",
          type: "item",
          url: "/facility-modelling",
          icon: icons.EnvironmentOutlined,
        },
        {
          id: "runway-airport-map",
          title: "Airport map",
          type: "item",
          url: "/airport-map",
          icon: icons.EnvironmentOutlined,
        },
        {
          id: "runway-crowd-simulation",
          title: "Crowd simulation",
          type: "item",
          url: "/crowd-simulation",
          icon: icons.CompassOutlined,
        },
        {
          id: "runway-crowd-simulation-2",
          title: "Crowd simulation 2",
          type: "item",
          url: "/crowd-simulation-2",
          icon: icons.CompassOutlined,
        },
        {
          id: "runway-create-task",
          title: "Create Task",
          type: "item",
          url: "/create-task",
          icon: icons.CalendarOutlined,
        },
        {
          id: "runway-issue-type",
          title: "Issue Type",
          type: "item",
          url: "/issue-type",
          icon: icons.CalendarOutlined,
        },
        {
          id: "runway-batch-edit",
          title: "Batch Edit",
          type: "item",
          url: "/batch-edit",
          icon: icons.CalendarOutlined,
        },
        {
          id: "runway-shift-scheduling",
          title: "Shift scheduling",
          type: "item",
          url: "/shift-scheduling",
          icon: icons.CalendarOutlined,
        },
        {
          id: "runway-access-management",
          title: "Access management",
          type: "item",
          url: "/access-management",
          icon: icons.TeamOutlined,
        },
      ],
    },
  ],
};

export default runway;
